import { SubscriptionProduct, ViewExperience } from '@chegg/rio-sdk-web'
import { Site } from '../types'
import { EventSchemas } from './rsw/eventSchemas'

export type EventWithConfig = {
  payload: EventSchemas
  config?: any
}

export const CHEGG_PRODUCT = 'chegg_writing' as SubscriptionProduct
export const EASYBIB_PRODUCT = 'easybib_plus' as SubscriptionProduct
export const BIBME_PRODUCT = 'bibme_plus' as SubscriptionProduct
export const CITATION_MACHINE_PRODUCT = 'citation_machine_plus' as SubscriptionProduct

export type ProductMap = { [key in Site]: SubscriptionProduct }

export const CHEGG_EXPERIENCE = 'cw' as ViewExperience
export const BIBME_EXPERIENCE = 'bm' as ViewExperience
export const CITATION_MACHINE_EXPERIENCE = 'cm' as ViewExperience
export const EASYBIB_EXPERIENCE = 'eb' as ViewExperience

export type ExperienceMap = { [key in Site]: ViewExperience }
